(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["doviar-bag-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    const LEAVE_AFTER_ADD = 650;
    const LEAVE_MS = 400;

    const setup = () => {
      const block = document.querySelector('[data-bag-upsell="drawer"]');
      const drawer = document.getElementById('DoviarCartDrawer');
      const content = drawer && drawer.querySelector('[data-cart-content]');
      if (!block || !content || block.dataset.ready) return;
      block.dataset.ready = 'true';
      content.append(block);

      const title = block.querySelector('[data-upsell-title]');
      const track = block.querySelector('[data-upsell-track]');
      const cards = [...block.querySelectorAll('[data-upsell-card]')];
      const arrows = [...block.querySelectorAll('[data-upsell-scroll]')];
      const max = Number(block.dataset.max) || 6;
      if (!cards.length) return;

      const updateArrows = () => {
        const end = track.scrollWidth - track.clientWidth - 2;
        arrows.forEach((arrow) => {
          arrow.disabled = Number(arrow.dataset.upsellScroll) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= end;
        });
      };

      const leave = (card) => {
        card.classList.add('is-leaving');
        setTimeout(() => {
          const hadFocus = card.contains(document.activeElement);
          card.hidden = true;
          card.classList.remove('is-leaving');
          card.querySelector('[data-upsell-add]')?.classList.remove('is-added');
          if (hadFocus) {
            const next = cards.find((other) => !other.hidden)?.querySelector('[data-upsell-add]');
            (next || drawer.querySelector('[data-cart-checkout]') || drawer.querySelector('.dv-cart-close'))?.focus({ preventScroll: true });
          }
          updateArrows();
        }, LEAVE_MS);
      };

      const sync = (cart) => {
        if (!cart || !Array.isArray(cart.items)) return;
        const inBag = new Set(cart.items.map((item) => String(item.product_id)));
        let shown = 0;
        cards.forEach((card) => {
          const eligible = !inBag.has(card.dataset.productId) && shown < max;
          if (eligible) {
            shown += 1;
            card.hidden = false;
            return;
          }
          if (card.hidden || card.classList.contains('is-leaving')) return;
          const button = card.querySelector('[data-upsell-add]');
          if (button && button.getAttribute('aria-busy') === 'true' && drawer.open) {
            button.classList.add('is-added');
            setTimeout(() => leave(card), LEAVE_AFTER_ADD);
          } else if (drawer.open && !block.hidden) {
            leave(card);
          } else {
            card.hidden = true;
          }
        });
        title.textContent = cart.item_count > 0 ? title.dataset.titleFilled : title.dataset.titleEmpty;
        block.hidden = shown === 0;
        requestAnimationFrame(updateArrows);
      };

      block.addEventListener('click', async (event) => {
        const arrow = event.target.closest('[data-upsell-scroll]');
        if (arrow) {
          track.scrollBy({ left: Number(arrow.dataset.upsellScroll) * track.clientWidth * 0.8, behavior: 'smooth' });
          return;
        }
        const button = event.target.closest('[data-upsell-add]');
        if (!button || !window.DoviarCart?.add || button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        try {
          await window.DoviarCart.add({ id: String(button.dataset.variantId), quantity: 1 }, { trigger: button });
        } catch (error) {
          // The bag drawer shows the reason; the suggestion simply stays in place.
        } finally {
          button.setAttribute('aria-busy', 'false');
        }
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      document.addEventListener('doviar:cart-updated', (event) => sync(event.detail && event.detail.cart));
      if (window.DoviarCart?.cart) sync(window.DoviarCart.cart);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doviar-cart-drawer"] && !Shopify.designMode) return;
  try {
    function createDoviarCartController(options) {
    let cart = null;
    let busy = false;
    const accept = (next) => {
      if (!next || !Array.isArray(next.items) || !Number.isFinite(next.item_count) || !Number.isFinite(next.total_price)) throw new Error(options.labels.loadError);
      cart = next;
      options.onCart(next);
    };
    const perform = async (action, payload, trigger) => {
      if (busy) throw new Error(options.labels.busy);
      busy = true;
      options.onBusy(true);
      options.onOpen(trigger);
      options.onError(null);
      options.onStatus(options.labels[action === 'add' ? 'adding' : action === 'change' ? 'updating' : 'loading']);
      let added = false;
      try {
        let result;
        if (action === 'read') result = await options.request(options.routes.cart + '.js');
        else {
          const sectionId = options.getSectionId();
          const body = action === 'add' ? { items: [payload] } : payload;
          if (sectionId) { body.sections = [sectionId]; body.sections_url = options.routes.cart; }
          result = await options.request(options.routes[action] + '.js', body);
          if (action === 'add') added = true;
          if (result.sections) options.onSections(result.sections);
          if (action === 'add') result = await options.request(options.routes.cart + '.js');
        }
        accept(result);
        options.onStatus(cart.item_count === 0 ? options.labels.empty : action === 'add' ? options.labels.added : options.labels.updated);
        return { cart, added };
      } catch (error) {
        const message = added ? options.labels.addedRefreshError : error.isResponse ? error.message : action === 'read' ? options.labels.loadError : options.labels.updateUncertain;
        options.onError(message);
        options.onStatus('');
        if (added) return { cart: null, added: true };
        if (action !== 'read') {
          try { accept(await options.request(options.routes.cart + '.js')); } catch {}
        }
        const failure = new Error(message);
        failure.cartError = true;
        throw failure;
      } finally {
        busy = false;
        options.onBusy(false);
      }
    };
    return {
      add(item, context = {}) {
        if (!/^\d+$/.test(String(item?.id)) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return Promise.reject(new Error(options.labels.invalidQuantity));
        return perform('add', { id: String(item.id), quantity: item.quantity, ...(item.properties ? { properties: item.properties } : {}) }, context.trigger);
      },
      change(key, quantity) {
        if (!key || !Number.isSafeInteger(quantity) || quantity < 0) { options.onError(options.labels.invalidQuantity); return Promise.reject(new Error(options.labels.invalidQuantity)); }
        return perform('change', { id: key, quantity });
      },
      open(context = {}) {
        if (busy) { options.onOpen(context.trigger); return Promise.resolve({ cart }); }
        return perform('read', null, context.trigger);
      },
      refresh() { return perform('read'); },
      get busy() { return busy; },
      get cart() { return cart; }
    };
  }
  function initializeDoviarCartDrawer() {
    const dialog = document.getElementById('DoviarCartDrawer');
    if (!dialog || window.DoviarCart || typeof dialog.showModal !== 'function') return;
    const config = JSON.parse(dialog.querySelector('[data-cart-config]').textContent);
    const list = dialog.querySelector('[data-cart-lines]');
    const lineTemplate = dialog.querySelector('[data-cart-line-template]');
    const closeButton = dialog.querySelector('.dv-cart-close');
    const checkout = dialog.querySelector('[data-cart-checkout]');
    let restoreTarget = null;
    let pendingFocus = null;
    let fresh = false;
    let uiBusy = false;
    let renderedCart = null;
    const format = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || config.currency }).format(Number(amount) / 100);
    const setStatus = (message) => { dialog.querySelector('[data-cart-status]').textContent = message; };
    const setError = (message) => {
      dialog.querySelector('[data-cart-error]').hidden = !message;
      dialog.querySelector('[data-cart-error-text]').textContent = message || '';
    };
    const updateControls = () => {
      dialog.querySelectorAll('[data-cart-action],[data-cart-quantity],[data-cart-retry]').forEach(control => { control.disabled = uiBusy; });
      checkout.disabled = uiBusy || !fresh || !renderedCart?.item_count;
      dialog.querySelector('[data-cart-content]').setAttribute('aria-busy', String(uiBusy));
    };
    const openDialog = (trigger) => {
      if (dialog.open) return;
      restoreTarget = trigger || document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('dv-cart-open');
      closeButton.focus({ preventScroll: true });
    };
    const safeProductUrl = (value) => {
      try { const url = new URL(value, window.location.origin); return url.origin === window.location.origin ? url.href : config.routes.cart; } catch { return config.routes.cart; }
    };
    const renderCart = (cart) => {
      renderedCart = cart;
      fresh = true;
      const fragment = document.createDocumentFragment();
      cart.items.forEach((item) => {
        const row = lineTemplate.content.firstElementChild.cloneNode(true);
        row.dataset.key = item.key;
        row.querySelector('[data-line-title]').textContent = item.product_title || item.title;
        row.querySelectorAll('[data-line-link]').forEach(link => { link.href = safeProductUrl(item.url); });
        row.querySelector('[data-line-price]').textContent = format(item.final_line_price, cart.currency);
        row.querySelector('[data-line-variant]').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const image = row.querySelector('[data-line-image]');
        const imageUrl = item.featured_image?.url || item.image;
        if (imageUrl) {
          try {
            const url = new URL(imageUrl, window.location.origin);
            if (url.protocol === 'https:' || url.protocol === 'http:') {
              if (url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.net') || url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/')) url.searchParams.set('width', '216');
              image.src = url.href;
            } else image.hidden = true;
          } catch { image.hidden = true; }
          image.alt = item.featured_image?.alt || item.product_title || item.title;
        } else image.hidden = true;
        const properties = row.querySelector('[data-line-properties]');
        Object.entries(item.properties || {}).forEach(([key, value]) => {
          if (key.startsWith('_') || value === '' || value == null) return;
          const text = document.createElement('p');
          text.textContent = key + ': ' + String(value);
          properties.append(text);
        });
        row.querySelector('[data-line-vip]').hidden = item.properties?._doviar_offer !== 'circle_vip' && !(item.variant_title || '').includes('Circle VIP offer');
        const discounts = row.querySelector('[data-line-discounts]');
        (item.line_level_discount_allocations || []).forEach(discount => {
          const text = document.createElement('p');
          text.textContent = discount.discount_application.title + ' (−' + format(discount.amount, cart.currency) + ')';
          discounts.append(text);
        });
        const quantity = row.querySelector('[data-cart-quantity]');
        quantity.value = item.quantity;
        quantity.setAttribute('aria-label', config.labels.quantityFor.replace('__PRODUCT__', item.product_title || item.title));
        ['decrease', 'increase', 'remove'].forEach(action => row.querySelector('[data-cart-action="' + action + '"]').setAttribute('aria-label', config.labels[action].replace('__PRODUCT__', item.product_title || item.title)));
        fragment.append(row);
      });
      list.replaceChildren(fragment);
      dialog.querySelector('[data-drawer-count]').textContent = '(' + cart.item_count + ')';
      dialog.querySelector('[data-cart-total]').textContent = format(cart.total_price, cart.currency) + ' ' + cart.currency;
      dialog.querySelector('[data-cart-empty]').hidden = cart.item_count !== 0;
      dialog.querySelector('[data-cart-footer]').hidden = cart.item_count === 0;
      document.querySelectorAll('.cart-count,[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
      document.querySelectorAll('.cart-link').forEach(link => link.setAttribute('aria-label', config.labels.bagCount.replace('__COUNT__', cart.item_count)));
      updateControls();
      document.dispatchEvent(new CustomEvent('doviar:cart-updated', { detail: { cart } }));
    };
    const request = async (url, body) => {
      const abort = new AbortController();
      const timeout = window.setTimeout(() => abort.abort(), 15000);
      try {
        const response = await fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}), signal: abort.signal });
        const result = await response.json();
        if (!response.ok) { const error = new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : config.labels.updateUncertain); error.isResponse = true; throw error; }
        return result;
      } finally { window.clearTimeout(timeout); }
    };
    const controller = createDoviarCartController({
      routes: config.routes,
      labels: config.labels,
      request,
      onCart: renderCart,
      onError: setError,
      onStatus: setStatus,
      onOpen: openDialog,
      getSectionId: () => document.querySelector('[data-doviar-cart-section]')?.dataset.sectionId,
      onSections: (sections) => {
        const current = document.querySelector('[data-doviar-cart-section]');
        const html = current && sections[current.dataset.sectionId];
        if (!html) return;
        const updated = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-doviar-cart-section]');
        if (updated) current.replaceWith(updated);
      },
      onBusy: (value) => {
        if (value) {
          const focused = document.activeElement;
          const focusedLine = focused?.closest?.('[data-cart-line]');
          pendingFocus = focusedLine ? { key: focusedLine.dataset.key, action: focused.dataset.cartAction, quantity: focused.hasAttribute('data-cart-quantity') } : null;
          fresh = false;
        }
        uiBusy = value;
        updateControls();
        if (!value && pendingFocus && dialog.open) {
          const row = [...dialog.querySelectorAll('[data-cart-line]')].find(item => item.dataset.key === pendingFocus.key);
          const target = row?.querySelector(pendingFocus.quantity ? '[data-cart-quantity]' : '[data-cart-action="' + pendingFocus.action + '"]');
          (target || closeButton).focus({ preventScroll: true });
          pendingFocus = null;
        }
      }
    });
    window.DoviarCart = controller;
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('.cart-link,[data-open-cart]');
      if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      controller.open({ trigger: link }).catch(() => {});
    });
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-close]')) { dialog.close(); return; }
      if (event.target.closest('[data-cart-retry]')) { controller.refresh().catch(() => {}); return; }
      const control = event.target.closest('[data-cart-action]');
      if (control && !controller.busy) {
        const row = control.closest('[data-cart-line]');
        const item = controller.cart?.items.find(line => line.key === row.dataset.key);
        if (!item) return;
        const quantity = control.dataset.cartAction === 'remove' ? 0 : item.quantity + (control.dataset.cartAction === 'increase' ? 1 : -1);
        controller.change(item.key, quantity).catch(() => {});
      }
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
    dialog.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input || controller.busy) return;
      const row = input.closest('[data-cart-line]');
      const quantity = Number(input.value);
      if (input.value.trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
        const item = controller.cart?.items.find(line => line.key === row.dataset.key);
        input.value = item?.quantity || 1;
        setError(config.labels.invalidQuantity);
        return;
      }
      controller.change(row.dataset.key, quantity).catch(() => {});
    });
    dialog.addEventListener('close', () => {
      pendingFocus = null;
      document.documentElement.classList.remove('dv-cart-open');
      const target = restoreTarget?.isConnected && !restoreTarget.disabled ? restoreTarget : document.querySelector('.cart-link');
      target?.focus({ preventScroll: true });
    });
  }
  initializeDoviarCartDrawer();
  document.addEventListener('shopify:section:load', initializeDoviarCartDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doviar-circle-access"] && !Shopify.designMode) return;
  try {
    (() => {
    const controllers = new Map();
    const cookieName = 'doviar_circle_access_v1';
    const removeCookie = () => { try { document.cookie = cookieName + '=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax; Secure'; } catch {} };
    const readCookie = () => {
      try {
        const pair = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(cookieName + '='));
        return pair ? decodeURIComponent(pair.slice(cookieName.length + 1)) : '';
      } catch { return ''; }
    };
    function initialize(scope = document) {
      scope.querySelectorAll('[data-circle-access]').forEach(root => {
        if (controllers.has(root)) return;
        const gate = root.querySelector('[data-circle-gate]');
        const catalog = root.querySelector('[data-circle-public-catalog]');
        const input = root.querySelector('[data-circle-code]');
        const submit = root.querySelector('[data-circle-submit]');
        const form = root.querySelector('[data-circle-form]');
        const error = root.querySelector('[data-circle-error]');
        const status = root.querySelector('[data-circle-status]');
        const forget = root.querySelector('[data-circle-forget]');
        if (!gate || !catalog || !input || !submit || !form || !error || !status || !forget) return;
        const member = root.dataset.circleMember === 'true' && root.dataset.circleOriginal === 'true';
        const entryMode = root.dataset.circleMode === 'entry';
        let redirecting = false;
        const redirect = destination => { if (root.dataset.circleOriginal === 'true' && !redirecting) { redirecting = true; window.location.replace(destination); } };
        const hash = root.dataset.circleOriginal === 'true' ? root.dataset.circleCodeHash : '';
        const days = Math.min(90, Math.max(1, Number(root.dataset.circleDays) || 30));
        const canCheckCode = Boolean(hash && /^[a-f0-9]{64}$/.test(hash) && window.crypto?.subtle && window.TextEncoder);
        let timer = null;
        let expiresAt = 0;
        let checking = false;
        let generation = 0;
        const setError = message => { error.textContent = message; error.hidden = !message; input.setAttribute('aria-invalid', String(Boolean(message))); };
        const reveal = (focus = false) => {
          gate.hidden = true; gate.inert = true; catalog.hidden = false; catalog.inert = false;
          forget.hidden = member;
          if (entryMode) { redirect(root.dataset.circleCollectionUrl); return; }
          if (focus) { const heading = catalog.querySelector('h1,h2'); if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); } }
        };
        const lock = (message = '') => {
          generation += 1; window.clearTimeout(timer); expiresAt = 0; removeCookie(); input.value = '';
          if (member) return;
          gate.hidden = false; gate.inert = false; catalog.hidden = true; catalog.inert = true; forget.hidden = true;
          status.textContent = message;
          if (!entryMode) redirect(root.dataset.circleGateUrl);
        };
        const scheduleExpiry = () => {
          window.clearTimeout(timer);
          const remaining = expiresAt - Date.now();
          if (remaining <= 0) { lock(root.dataset.circleExpired); return; }
          timer = window.setTimeout(scheduleExpiry, Math.min(remaining, 2147483647));
        };
        const restore = () => {
          if (member) return;
          const saved = readCookie();
          if (!saved) return;
          const parts = saved.split(':');
          const expiry = Number(parts[2]);
          if (!canCheckCode || parts.length !== 3 || parts[0] !== 'v1' || parts[1] !== hash || !Number.isSafeInteger(expiry) || expiry <= Date.now() || expiry > Date.now() + days * 86400000) {
            lock(expiry <= Date.now() ? root.dataset.circleExpired : ''); return;
          }
          expiresAt = expiry; reveal(); scheduleExpiry();
        };
        const onSubmit = async event => {
          event.preventDefault();
          if (checking || !canCheckCode || member) return;
          const code = input.value.trim();
          setError('');
          if (!code) { setError(root.dataset.circleBlank); input.focus(); return; }
          checking = true; input.disabled = true; submit.disabled = true; form.setAttribute('aria-busy', 'true');
          status.textContent = root.dataset.circleChecking;
          const attempt = generation;
          try {
            const digest = await window.crypto.subtle.digest('SHA-256', new window.TextEncoder().encode(code));
            if (attempt !== generation) return;
            const enteredHash = [...new Uint8Array(digest)].map(value => value.toString(16).padStart(2, '0')).join('');
            if (enteredHash !== hash) { setError(root.dataset.circleIncorrect); status.textContent = ''; return; }
            expiresAt = Date.now() + days * 86400000;
            const value = 'v1:' + hash + ':' + expiresAt;
            try { document.cookie = cookieName + '=' + encodeURIComponent(value) + '; Max-Age=' + Math.floor(days * 86400) + '; Expires=' + new Date(expiresAt).toUTCString() + '; Path=/; SameSite=Lax; Secure'; } catch {}
            const remembered = readCookie() === value;
            if (entryMode && !remembered) { expiresAt = 0; status.textContent = root.dataset.circleCookieRequired; return; }
            status.textContent = remembered ? root.dataset.circleWelcome : root.dataset.circleMemoryOnly;
            reveal(true); scheduleExpiry();
          } catch { setError(root.dataset.circleUnsupported); status.textContent = ''; }
          finally { input.value = ''; checking = false; input.disabled = !canCheckCode; submit.disabled = !canCheckCode; form.setAttribute('aria-busy', 'false'); }
        };
        const onForget = () => { lock(root.dataset.circleForgotten); if (!input.disabled) input.focus({ preventScroll: true }); };
        const onInput = () => setError('');
        form.addEventListener('submit', onSubmit); forget.addEventListener('click', onForget); input.addEventListener('input', onInput);
        if (member) { removeCookie(); reveal(); }
        else {
          input.disabled = !canCheckCode; submit.disabled = !canCheckCode;
          if (hash && !canCheckCode) setError(root.dataset.circleUnsupported);
          restore();
          if (!entryMode && catalog.hidden) redirect(root.dataset.circleGateUrl);
        }
        controllers.set(root, {
          recheck() { if (!member && expiresAt && expiresAt <= Date.now()) lock(root.dataset.circleExpired); },
          destroy() { generation += 1; window.clearTimeout(timer); input.value = ''; form.removeEventListener('submit', onSubmit); forget.removeEventListener('click', onForget); input.removeEventListener('input', onInput); controllers.delete(root); }
        });
      });
    }
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => controllers.forEach((controller, root) => { if (event.target.contains(root)) controller.destroy(); }));
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') controllers.forEach(controller => controller.recheck()); });
    window.addEventListener('pageshow', () => controllers.forEach(controller => controller.recheck()));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doviar-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const motion = window.matchMedia ? window.matchMedia('not all') : { matches: false };
    const EASE = 'cubic-bezier(.22, 1, .36, 1)';

    // Bag: hide the internal option name; the cart data itself is untouched
    const tidyBag = () => {
      document.querySelectorAll('[data-line-variant]').forEach((el) => {
        const text = el.textContent.replace(/\s*\/\s*One-time purchase\s*$/, '').replace(/^\s*One-time purchase\s*$/, '');
        if (text !== el.textContent) el.textContent = text;
      });
      document.querySelectorAll('[data-line-properties] p').forEach((el) => {
        if (/^Purchase option:/.test(el.textContent)) el.remove();
      });
      document.querySelectorAll('[data-line-title]').forEach((el) => {
        const parts = el.textContent.split(' — ');
        if (parts.length < 2) return;
        el.textContent = parts[0];
        const variant = el.closest('.dv-cart-line-info')?.querySelector('[data-line-variant]');
        if (variant && !variant.textContent.trim()) variant.textContent = parts.slice(1).join(' — ');
      });
    };
    document.addEventListener('doviar:cart-updated', tidyBag);

    // Scroll-linked work: header elevation, hero parallax, photo parallax
    const hero = document.querySelector('.template-index .hero-art');
    const parallax = motion.matches ? [] : [...document.querySelectorAll('.dv-photo-story-media img, .editorial-image img, .featured-photo [data-featured-image] img')];
    parallax.forEach((img) => { img.style.scale = '1.08'; });
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const h = window.innerHeight;
        root.classList.toggle('dv-scrolled', y > 8);
        const room = document.documentElement.scrollHeight - h;
        root.style.setProperty('--dv-progress', room > 0 ? Math.min(1, y / room).toFixed(4) : '0');
        if (hero && !motion.matches && y < h * 1.2) hero.style.setProperty('--dv-parallax', Math.round(y * 0.12) + 'px');
        parallax.forEach((img) => {
          const frame = img.parentElement.getBoundingClientRect();
          if (frame.bottom < -50 || frame.top > h + 50) return;
          const progress = (frame.top + frame.height / 2 - h / 2) / h;
          img.style.translate = '0 ' + (progress * -36).toFixed(1) + 'px';
        });
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    // Lazy images below the fold (and every product-card image) blur in once loaded
    const fadeImages = () => {
      const fold = window.innerHeight;
      document.querySelectorAll('img[loading="lazy"], .dv-card-media img').forEach((img) => {
        if (img.complete || img.dataset.dvFade || img.loading === 'eager' || img.closest('.dv-cart-drawer,[data-age-gate]')) return;
        if (!img.closest('.dv-card-media') && img.getBoundingClientRect().top < fold) return;
        img.dataset.dvFade = 'true';
        img.classList.add('dv-img-fade', 'dv-img-wait');
        const done = () => requestAnimationFrame(() => img.classList.remove('dv-img-wait'));
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        if (img.complete) done();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fadeImages, { once: true });
    else fadeImages();
    document.addEventListener('shopify:section:load', fadeImages);

    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;

    const UNIT = 'h1,h2,h3,.eyebrow,p,.button,.text-link,img,video,li,article,details,.swatches,.brand-strip,form,blockquote,table';
    const SKIP = '[data-age-gate],.dv-cart-drawer,.site-header,.site-footer,[data-sticky-buy],[data-dv-static],[data-dv-stagger],[data-dv-wordmark],.template-index .hero,.pdp-simple';

    // Staggered cascades, started once the age check is answered so they play where they can be seen
    const gateOpen = () => {
      const gate = document.querySelector('[data-age-gate]');
      return gate && gate.isConnected && !gate.hidden && getComputedStyle(gate).display !== 'none';
    };
    const staggerObserver = new IntersectionObserver((entries) => {
      const batch = entries
        .filter((entry) => entry.isIntersecting)
        .map((entry) => entry.target)
        .sort((a, b) => (a.getBoundingClientRect().top - b.getBoundingClientRect().top) || (a.getBoundingClientRect().left - b.getBoundingClientRect().left));
      batch.forEach((item, index) => {
        staggerObserver.unobserve(item);
        item.style.setProperty('--dv-delay', Math.min(index, 6) * 60 + 'ms');
        item.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    const stagger = (scope = document) => {
      if (gateOpen()) { setTimeout(() => stagger(scope), 160); return; }
      scope.querySelectorAll('[data-dv-stagger] > [data-dv-item]:not(.is-in)').forEach((item) => staggerObserver.observe(item));
    };
    stagger();
    document.addEventListener('shopify:section:load', (event) => stagger(event.target));
    const pending = new Set();

    const unitsIn = (section) => {
      const all = [...section.querySelectorAll(UNIT)].filter((el) => !el.closest(SKIP));
      const set = new Set(all);
      return all.filter((el) => {
        for (let parent = el.parentElement; parent && parent !== section; parent = parent.parentElement) {
          if (set.has(parent)) return false;
        }
        return true;
      });
    };

    // Headings made of plain text reveal word by word
    const splitWords = (el) => {
      if (!el.matches('h2') || el.children.length || el.dataset.dvSplit) return;
      const text = el.textContent.trim();
      if (!text || text.length > 120) return;
      el.setAttribute('aria-label', text);
      el.textContent = '';
      text.split(/\s+/).forEach((word, index) => {
        if (index) el.append(' ');
        const outer = document.createElement('span');
        outer.className = 'dv-w';
        outer.setAttribute('aria-hidden', 'true');
        const inner = document.createElement('span');
        inner.textContent = word;
        outer.append(inner);
        el.append(outer);
      });
      el.dataset.dvSplit = 'true';
    };

    const keyframesFor = (el) => {
      if (el.matches('img,video')) {
        return {
          frames: [
            { opacity: 0, transform: 'scale(1.05)', clipPath: 'inset(8% 0 0 0)' },
            { opacity: 1, transform: 'scale(1)', clipPath: 'inset(0 0 0 0)' }
          ],
          duration: 950
        };
      }
      if (el.matches('h1,h2')) {
        return {
          frames: [
            { opacity: 0, transform: 'translateY(20px)', filter: 'blur(4px)' },
            { opacity: 1, transform: 'translateY(0)', filter: 'blur(0)' }
          ],
          duration: 850
        };
      }
      return {
        frames: [
          { opacity: 0, transform: 'translateY(16px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        duration: 700
      };
    };

    const reveal = (el, delay) => {
      pending.delete(el);
      if (!el.classList.contains('dv-r')) return;
      try {
        if (el.dataset.dvSplit) {
          el.querySelectorAll('.dv-w > span').forEach((word, index) => {
            word.animate([{ transform: 'translateY(110%)' }, { transform: 'translateY(0)' }], { duration: 800, delay: delay + index * 45, easing: EASE, fill: 'backwards' });
          });
        } else {
          const { frames, duration } = keyframesFor(el);
          el.animate(frames, { duration, delay, easing: EASE, fill: 'backwards' });
        }
      } catch {}
      el.classList.remove('dv-r');
    };

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => (a.boundingClientRect.top - b.boundingClientRect.top) || (a.boundingClientRect.left - b.boundingClientRect.left));
      visible.forEach((entry, index) => {
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(index, 6) * 60);
      });
    }, { threshold: 0, rootMargin: '0px' });

    const wordmarkObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        wordmarkObserver.unobserve(entry.target);
        entry.target.classList.remove('dv-wm-pending');
        requestAnimationFrame(() => entry.target.classList.add('is-in'));
      });
    }, { threshold: 0 });

    const prepare = (scope = document) => {
      if (motion.matches) return;
      const sections = scope.matches && scope.matches('.shopify-section')
        ? [scope]
        : [...scope.querySelectorAll('#MainContent > .shopify-section, #shopify-section-doviar-footer')];
      const fold = window.innerHeight;
      sections.forEach((section) => {
        unitsIn(section).forEach((el) => {
          if (pending.has(el) || !el.getClientRects().length) return;
          if (el.getBoundingClientRect().top < fold - 10) return;
          splitWords(el);
          el.classList.add('dv-r');
          pending.add(el);
          observer.observe(el);
        });
        section.querySelectorAll('[data-dv-wordmark]').forEach((mark) => {
          if (mark.getBoundingClientRect().top < fold) return;
          mark.classList.add('dv-wm-pending');
          wordmarkObserver.observe(mark);
        });
      });
    };

    const releaseAll = () => {
      observer.disconnect();
      wordmarkObserver.disconnect();
      pending.forEach((el) => el.classList.remove('dv-r'));
      pending.clear();
      document.querySelectorAll('.dv-wm-pending').forEach((el) => el.classList.remove('dv-wm-pending'));
    };

    // Never leave focused content hidden
    document.addEventListener('focusin', (event) => {
      const hidden = event.target.closest && event.target.closest('.dv-r');
      if (hidden) reveal(hidden, 0);
    });

    const onPreference = () => { if (motion.matches) releaseAll(); };
    if (motion.addEventListener) motion.addEventListener('change', onPreference);

    document.addEventListener('shopify:section:load', (event) => prepare(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.dv-r').forEach((el) => { observer.unobserve(el); el.classList.remove('dv-r'); pending.delete(el); });
    });
    window.addEventListener('beforeprint', releaseAll);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
    else prepare();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doviar-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__dvCards) return;
    window.__dvCards = true;

    // Touch: keep the dots in step with the swiped photo
    document.addEventListener('scroll', (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.matches('[data-dv-track]')) return;
      const dots = track.parentElement.querySelectorAll('.dv-card-dots i');
      if (!dots.length) return;
      const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
    }, { capture: true, passive: true });

    // Mouse: tilt the photo a few degrees toward the pointer and move the sheen with it
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    let frame = 0;
    let pending = null;
    const apply = () => {
      frame = 0;
      if (!pending) return;
      const { media, x, y } = pending;
      media.style.setProperty('--dv-ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
      media.style.setProperty('--dv-rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
      media.style.setProperty('--dv-mx', (x * 100).toFixed(1) + '%');
      media.style.setProperty('--dv-my', (y * 100).toFixed(1) + '%');
    };
    document.addEventListener('pointermove', (event) => {
      const media = event.target instanceof Element && event.target.closest('[data-dv-tilt]');
      if (!media) return;
      const rect = media.getBoundingClientRect();
      pending = { media, x: (event.clientX - rect.left) / rect.width, y: (event.clientY - rect.top) / rect.height };
      if (!frame) frame = requestAnimationFrame(apply);
    }, { passive: true });
    document.addEventListener('pointerout', (event) => {
      const media = event.target instanceof Element && event.target.closest('[data-dv-tilt]');
      if (!media || (event.relatedTarget instanceof Node && media.contains(event.relatedTarget))) return;
      pending = null;
      ['--dv-rx', '--dv-ry'].forEach((name) => media.style.setProperty(name, '0deg'));
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
